import { ApiError } from '../api/client';

export function ProblemBanner({ error }: { error: unknown }) {
  if (error instanceof ApiError) {
    return (
      <div className="problem" role="alert">
        <b>{error.problem.title}</b>
        {error.problem.detail}
        {error.problem.errors?.map((e) => (
          <div key={e.path}>
            {e.path}: {e.message}
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className="problem" role="alert">
      <b>Something went wrong</b>
      {error instanceof Error ? error.message : String(error)}
    </div>
  );
}
